// Perguntas da visita — o contrato que a API e a tela compartilham.
//
// Pedido do Ilton (27/09): na visita, uma pergunta por tela, com a resposta que
// faz sentido ao lado e as que soam bem mas nao estao certas; ele marca como
// foi respondida e GRAVA a resposta, que o servidor transcreve.

export interface PerguntaDoRoteiro {
  /** "abertura" e "fecho" sao falas, nao perguntas: nao se grava nem se marca. */
  tipo?: 'abertura' | 'fecho';
  /** "1 · Sódio (o sal do sangue)" */
  tema: string;
  /** O que ler em voz alta, do jeito que se fala. */
  fala: string;
  /** Os números do exame, curtos: "23/09 134". */
  numeros?: string[];
  /** O que se espera ouvir. */
  certa?: string[];
  /** [frase que soa bem mas não está certa, por quê]. */
  cuidado?: [string, string][];
  /** Para falas: o lembrete de como dizer. */
  dica?: string;
}

export type MarcaDaPergunta = 'ok' | 'vago' | 'pulou';

export const ROTULO_MARCA: Record<MarcaDaPergunta, string> = {
  ok: 'Respondeu', vago: 'Ficou vago', pulou: 'Pulei',
};

export type SituacaoDaGravacao = 'pendente' | 'transcrevendo' | 'transcrita' | 'erro';

export interface GravacaoDTO {
  id: string;
  indice: number;
  gravadoEm: string;
  duracaoSeg: number | null;
  bytes: number;
  situacao: SituacaoDaGravacao;
  transcricao: string | null;
  analise: string | null;
  falha: string | null;
  autor: string | null;
}

export interface RoteiroDTO {
  id: string;
  titulo: string;
  paraDia: string;
  ativo: boolean;
  perguntas: PerguntaDoRoteiro[];
  marcas: Record<number, { marca: MarcaDaPergunta | null; nota: string | null }>;
  gravacoes: GravacaoDTO[];
  /** Quem está vendo pode ouvir os áudios? (só o admin) */
  podeOuvir: boolean;
}

export interface ResumoRoteiroDTO {
  id: string;
  titulo: string;
  paraDia: string;
  ativo: boolean;
  /** Só as perguntas de verdade — abertura e fecho não contam. */
  perguntas: number;
  marcadas: number;
  gravacoes: number;
}

/**
 * Os formatos que o celular grava e o transcritor aceita. O iPhone grava
 * "audio/mp4" (AAC); o Android/Chrome, "audio/webm" (Opus).
 */
const EXTENSAO: Record<string, string> = {
  'audio/mp4': 'm4a', 'audio/x-m4a': 'm4a', 'audio/m4a': 'm4a', 'audio/aac': 'm4a',
  'audio/webm': 'webm', 'audio/ogg': 'ogg', 'audio/mpeg': 'mp3', 'audio/wav': 'wav', 'audio/x-wav': 'wav',
};

/** "audio/webm;codecs=opus" -> "audio/webm". */
export const tipoBaseDoAudio = (mime: string): string => mime.split(';')[0]!.trim().toLowerCase();

/** A extensão do arquivo, ou null quando o formato não serve. */
export const extensaoDoAudio = (mime: string): string | null => EXTENSAO[tipoBaseDoAudio(mime)] ?? null;

/** Perguntas de verdade (as que se marcam e gravam). */
export const ehPergunta = (p: PerguntaDoRoteiro): boolean => !p.tipo;
